/* src/app/timeline-skip/pages/timeline-skip/timeline-skip.component.scss */
.timelineContainer {
  display: flex;
  flex-flow: row wrap;
}
.orderContainer {
  background-color: #bdc3c7;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=timeline-skip.component.css.map */
